/* Father's Day v7 PDP gallery — arrows + thumbnail sync for the scroll-snap slider.
   Loaded globally (like fathers-day-sticky.js) so it runs even when GemPages inserts
   the markup lazily via innerHTML, where inline <script> tags never execute.
   Native touch/drag swipe comes free from CSS scroll-snap; this only wires the arrow
   buttons, thumbnail clicks, and active-thumb highlighting to the scroll position
   (the scroll offset is the single source of truth, so arrows/swipe/thumbs stay in sync). */
(function () {
  function setup(g) {
    if (g.dataset.fdGalleryInit) return;
    var stage = g.querySelector('[data-fd-stage]');
    if (!stage) return;
    g.dataset.fdGalleryInit = '1';

    var slides = g.querySelectorAll('.fd-rpdp__slide');
    var thumbs = g.querySelectorAll('[data-fd-thumb]');
    var prev = g.querySelector('[data-fd-prev]');
    var next = g.querySelector('[data-fd-next]');
    var count = slides.length;

    function index() {
      var w = stage.clientWidth || 1;
      return Math.round(stage.scrollLeft / w);
    }
    function go(i) {
      if (i < 0) i = 0;
      if (i > count - 1) i = count - 1;
      stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    for (var t = 0; t < thumbs.length; t++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          go(parseInt(btn.getAttribute('data-fd-thumb'), 10) || 0);
        });
      })(thumbs[t]);
    }

    var raf;
    function sync() {
      var i = index();
      for (var k = 0; k < thumbs.length; k++) {
        thumbs[k].classList.toggle('is-active', k === i);
      }
      if (prev) prev.style.visibility = i <= 0 ? 'hidden' : 'visible';
      if (next) next.style.visibility = i >= count - 1 ? 'hidden' : 'visible';
    }
    stage.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    });
    sync();
  }

  function init() {
    var gals = document.querySelectorAll('.fd-rpdp__gallery');
    for (var i = 0; i < gals.length; i++) setup(gals[i]);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
  window.addEventListener('load', init);

  // Catch GemPages (and other) lazily-inserted instances.
  if ('MutationObserver' in window) {
    new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
